<div class="payroll-period-wrapper" *ngIf="payrollPeriod" tid="payroll-period">
  <app-body-sm ink="primary" bold>Period {{ payrollPeriod.payrollPeriod }}</app-body-sm>
  <app-body-sm ink="primary" bold> ({{ payrollPeriod.usualPayDate | date : 'dd MMM yyyy' }}) </app-body-sm>
</div>
